
import imgHome from '../components/menu/svg/Home.svg';
import { BriefcaseBusinessIcon, ChartColumn, ChartPie, Contact, FolderPlus, House, Lightbulb, ListTodo, Receipt, ReceiptText, Settings, Sheet, Wallet } from 'lucide-react';

export const menuOptionsUserTask = [
    { id: 1, title: 'Inicio', path: '/inicio', path_select: 'inicio', icon: <img src={imgHome} alt="Inicio" />, show: true, submenus: [] },
    {
        id: 4, title: 'Proyectos', path: '/proyectos/ut', path_select: '/proyectos/ut',
        icon: <FolderPlus size={20} color='#645e64' strokeWidth={2.5} />,
        show: true, submenus: []
    },
    { id: 10, title: 'Tareas', path: '/tasks/home', path_select: 'tasks/home', icon: <i className="bi bi-list-task" style={{ color: '#645e64', fontSize: '22px', fontWeight: 'bold' }}></i>, show: true, submenus: [] },
]

export const getMenuOptions = (access, perfil, idPro) => {

    const showOportunidad = access.a14

    let menuOptions = []

    if (perfil === 9) {

        menuOptions = [
            // { id: 1, title: 'Inicio', path: '/inicio', path_select: 'inicio', icon: <img src={imgHome} alt="Inicio" />, show: true, submenus: [] },
            { id: 4, title: 'Proyectos', path: '/projects', path_select: 'projects', icon: <i className="bi bi-folder-plus" style={{ color: '#645e64', fontSize: '18px', fontWeight: 'bold' }}></i>, show: true, submenus: [] },
            { id: 10, title: 'Tareas', path: 'tasks', path_select: 'tasks', icon: <i className="bi bi-list-task" style={{ color: '#645e64', fontSize: '22px', fontWeight: 'bold' }}></i>, show: true, submenus: [] },
        ]

    } else {

        menuOptions = [
            {
                id: 1, title: 'Inicio', path: '/inicio', path_select: 'inicio',
                icon: <House size={18} color='#645e64' strokeWidth={2} />,
                iconActive: <House size={18} color='#8E24AA' strokeWidth={2} />,
                show: true, submenus: []
            },
            {
                id: 2, title: 'Dashboard', path: '/dashboard', path_select: 'dashboard',
                /* icon: <i className={`bi bi-caret-down-fill bi-caret-right-fill p-icon-sub-menu`}></i>, */
                show: access.a15,
                icon: <ChartPie size={18} color='#645e64' strokeWidth={2} />,
                iconActive: <ChartPie size={18} color='#8E24AA' strokeWidth={2} />,
                submenus: [
                    { id: 1, title: 'Presupuestos', path: '/dashboard/pptos', path_select: '/dashboard/pptos', icon: <i className="bi bi-graph-up-arrow"></i>, show: true, submenus: [] },
                    { id: 2, title: 'Ventas', path: '/dashboard/ventas', path_select: '/dashboard/ventas', icon: <i className="bi bi-graph-up"></i>, show: true, submenus: [] },
                    { id: 3, title: 'Gastos', path: '/dashboard/gastos', path_select: '/dashboard/gastos', icon: <i className="bi bi-graph-down"></i>, show: true, submenus: [] },
                ]
            },
            {
                id: 3, title: 'Oportunidades', path: '/crm', path_select: 'crm',
                icon: <Lightbulb size={18} color='#645e64' strokeWidth={2} />,
                iconActive: <Lightbulb size={18} color='#8E24AA' strokeWidth={2} />,
                show: showOportunidad, submenus: []
            },
            {
                id: 4, title: 'Presupuestos', path: '/ppto', path_select: 'ppto',
                icon: <Sheet size={18} color='#645e64' strokeWidth={2} />,
                iconActive: <Sheet size={18} color='#8E24AA' strokeWidth={2} />,
                show: access.a12, submenus: []
            },
            {
                id: 5, title: 'Proyectos', path: 'projects', path_select: 'projects',
                icon: <FolderPlus size={18} color='#645e64' strokeWidth={2} />,
                iconActive: <FolderPlus size={18} color='#8E24AA' strokeWidth={2} />,
                show: access.a13, submenus: []
            },
            {
                id: 6,
                title: 'Tareas',
                path: '/tasks',
                path_select: 'tasks',
                icon: <ListTodo size={18} color='#645e64' strokeWidth={2} />,
                iconActive: <ListTodo size={18} color='#8E24AA' strokeWidth={2} />,
                show: access.a26, submenus: []
            },
            {
                id: 7, title: 'Gastos', path: '/gastos/compras', path_select: 'gastos',
                icon: <Receipt size={18} color='#645e64' strokeWidth={2} />,
                iconActive: <Receipt size={18} color='#8E24AA' strokeWidth={2} />,
                show: access.a11, submenus: []
            },
            {
                id: 8, title: 'Facturas', path: '/facturas/?q=pc', path_select: 'facturas',
                icon: <ReceiptText size={18} color='#645e64' strokeWidth={2} />,
                iconActive: <ReceiptText size={18} color='#8E24AA' strokeWidth={2} />,
                show: access.a10, submenus: []
            },
            {
                id: 9, title: 'Bancos', path: '/banks/tra', path_select: 'banks/tra',
                icon: <Wallet size={18} color='#645e64' strokeWidth={2} />,
                iconActive: <Wallet size={18} color='#8E24AA' strokeWidth={2} />,
                show: access.a27, submenus: []
            },
            {
                id: 10, title: 'Servicios', path: '/catalogo', path_select: 'catalogo',
                icon: <BriefcaseBusinessIcon size={18} color='#645e64' strokeWidth={2} />,
                iconActive: <BriefcaseBusinessIcon size={18} color='#8E24AA' strokeWidth={2} />,
                show: access.a9, submenus: []
            },
            {
                id: 11, title: 'Contactos', path: '/contactos', path_select: 'contactos',
                icon: <Contact size={18} color='#645e64' strokeWidth={2} />,
                iconActive: <Contact size={18} color='#8E24AA' strokeWidth={2} />,
                show: access.a8, submenus: []
            },
            {
                id: 12, title: 'Reportes', path: '/reportes', path_select: 'reportes',
                icon: <ChartColumn size={18} color='#645e64' strokeWidth={2} />,
                iconActive: <ChartColumn size={18} color='#8E24AA' strokeWidth={2} />,
                show: !access.a25, submenus: []
            },
            {
                id: 13, title: 'Ajustes', path: '/ajustes/cuenta', path_select: 'ajustes',
                icon: <Settings size={18} color='#645e64' strokeWidth={2} />,
                iconActive: <Settings size={18} color='#8E24AA' strokeWidth={2} />,
                show: access.a7, submenus: []
            }
        ]

    }

    return menuOptions

}
